import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-private-policy',
  templateUrl: './private-policy.component.html',
  styleUrls: ['./private-policy.component.scss']
})
export class PrivatePolicyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
